<template>
  <v-row>
    <v-col cols="12" sm="auto">
      <v-select
        label="Workviews"
        v-model="selectedCustomWorkview"
        :items="customWorkviews"
        item-text="name"
        return-object
        clearable
        dense
        no-data-text="No Workviews"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="auto">
      <v-dialog v-model="dialog" width="400">
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            small
            rounded
            outlined
            @click="openDialog"
            :disabled="Boolean(selectedCustomWorkview) && !isDirty"
            >{{
              Boolean(selectedCustomWorkview)
                ? "Save Changes"
                : "Create Workview"
            }}</v-btn
          ></template
        ><v-card
          ><v-card-title>{{
            Boolean(selectedCustomWorkview)
              ? "Edit Workview"
              : "Create Workview"
          }}</v-card-title
          ><v-card-text
            ><v-text-field
              label="Name"
              v-model="name"
              :error-messages="invalidName"
            ></v-text-field></v-card-text
          ><v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="dialog = false" color="primary" text>Cancel</v-btn>
            <v-btn
              @click="saveCustomWorkview"
              color="primary"
              :disabled="Boolean(invalidName)"
              >Save</v-btn
            ></v-card-actions
          ></v-card
        ></v-dialog
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return { name: null, dialog: false };
  },
  async mounted() {
    await this.$store.dispatch("plansModule/getCustomWorkviewsForUser");
  },
  computed: {
    invalidName() {
      if (this.customWorkviews.map((x) => x.name).includes(this.name)) {
        return "There is already a workview with this name.";
      }
    },
    userId() {
      return this.$store.getters["securityModule/getUserId"];
    },
    isDirty() {
      return (
        this.$store.getters["plansModule/isColumnsDirty"] ||
        this.$store.getters["plansModule/isFiltersDirty"]
      );
    },
    customWorkviews() {
      return this.$store.state.plansModule.customWorkviews;
    },
    selectedCustomWorkview: {
      get() {
        return this.$store.state.plansModule.selectedCustomWorkview;
      },
      set(value) {
        this.$emit("applyDefault");
        if (value != null) {
          this.$store.dispatch("plansModule/setSelectedCustomWorkview", value);
        }
      },
    },
  },
  methods: {
    openDialog() {
      this.name = this.selectedCustomWorkview?.name;
      if (
        this.selectedCustomWorkview &&
        this.selectedCustomWorkview?.userId == null
      ) {
        this.name += " COPY";
      }
      this.dialog = true;
    },
    saveCustomWorkview() {
      if (
        Boolean(this.selectedCustomWorkview) &&
        this.userId == this.selectedCustomWorkview.userId
      ) {
        this.$store.dispatch("plansModule/updateCustomWorkview", this.name);
      } else {
        this.$store.dispatch("plansModule/createCustomWorkview", this.name);
      }
      this.dialog = false;
    },
  },
};
</script>